module.exports = __webpack_public_path__ + "img/Leadership_and_Team_Management_for_Engineering.cc515e23.jpeg";